module.exports = __webpack_public_path__ + "img/plus.10279ef2.svg";